import React from "react";
import {
  Dialog,
  DialogContent,
  Button,
  Select,
  MenuItem,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import "../css/RejectFlightPlanDialog.css";
import { ACCOUNT_REJECTION_REASON } from "../../utils/constants";

const RejectFlightPlanDialog = ({
  open,
  onClose,
  onSave,
  isAAUser,
  isLoading,
  flightPlanDetail,
  editedFlightDetails,
  setEditedFlightDetails,
}) => {
  const handleReasonChange = (event) => {
    setEditedFlightDetails({
      ...editedFlightDetails,
      differentCountReason: event.target.value,
    });
  };

  return (
    <Dialog
      open={open ?? false}
      onClose={onClose}
      PaperProps={{
        className: "reject-flight-plan-dialog-container",
        sx: { borderRadius: "1px" },
      }}
    >
      <DialogContent>
        <CloseOutlined
          className="reject-flight-plan-dialog-close"
          onClick={onClose}
        />
        <div className="reject-flight-plan-dialog-content">
          <div className="reject-flight-plan-dialog-title-container reject-flight-plan-dialog-margin-bottom">
            <div className="reject-flight-plan-dialog-title">
              Boarded and screened Count is not the same. Please provide
              reasons.
            </div>
            <div className="reject-flight-plan-dialog-subtitle">
              {`Boarded ${
                editedFlightDetails?.passengerBoardingCount
              } | Screened ${
                isAAUser
                  ? editedFlightDetails?.scannedPassengerCount
                  : flightPlanDetail?.scannedPassengerCount
              }`}
            </div>
          </div>
          <div className="reject-flight-plan-select-title">Select reason</div>
          <Select
            className="reject-flight-plan-select-container"
            value={editedFlightDetails?.differentCountReason}
            onChange={handleReasonChange}
            renderValue={(selected) =>
              ACCOUNT_REJECTION_REASON.find((type) => type.value === selected)
                ?.label
            }
          >
            {ACCOUNT_REJECTION_REASON.map((type) => (
              <MenuItem key={type.value} value={type.value}>
                <ListItemText primary={type.label} />
              </MenuItem>
            ))}
          </Select>
          <Button
            variant="contained"
            color="secondaryButton"
            disabled={
              !editedFlightDetails?.differentCountReason ||
              editedFlightDetails?.differentCountReason === ""
            }
            onClick={!isLoading ? onSave : null}
            endIcon={
              isLoading ? <CircularProgress size={30} color="inherit" /> : null
            }
          >
            Save
          </Button>
          <Button variant="contained" color="reject" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RejectFlightPlanDialog;
